import React from 'react';
import { FormControl, Select, MenuItem, Box, Typography } from '@mui/material';

interface YearSelectorProps {
  years: number[];
  selectedYear: number;
  onYearChange: (year: number) => void;
  disabled?: boolean;
}

export const YearSelector: React.FC<YearSelectorProps> = ({
  years,
  selectedYear,
  onYearChange,
  disabled = false,
}) => {
  // Sort years in reverse order (most recent first)
  const sortedYears = [...years].sort((a, b) => b - a);

  return (
    <Box sx={{ minWidth: 95 }}>
      <FormControl size="small" fullWidth disabled={disabled}>
        <Select
          value={selectedYear}
          onChange={(e) => onYearChange(Number(e.target.value))}
          displayEmpty
        >
          {sortedYears.map((year) => (
            <MenuItem key={year} value={year}>
              <Typography variant="large">{year}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
